import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,

} from "components/Resume/ResumePDF/common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject } from "lib/redux/types";
import { ResumePDFDescription, TemplateTwentyOnePDFSection, TemplateTwentyOneSectionWithSubsections } from "./common";

export const Project = ({
  heading,
  projects,
  themeColor,
  isPDF,
}: {
  heading: string;
  projects: ResumeProject[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateTwentyOneSectionWithSubsections themeColor={themeColor} heading={heading}>
      {projects.map(
        ({ project, startDate, endDate, descriptions, projectLink }, idx) => (
          <View key={idx} wrap={false}>
            <View
              style={{
                ...styles.flexCol,
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText  bold={true}>{project}</ResumePDFText>
                {projectLink && (
                  <ProjectPDFLink src={projectLink}>
                    <ResumePDFIcon
                      type="url"
                      isPDF={isPDF}
                      themeColor={"black"}
                    />
                  </ProjectPDFLink>
                )}
              </View>
              <ResumePDFText >
                {startDate && endDate
                  ? `${startDate} - ${endDate}`
                  : startDate || endDate}
              </ResumePDFText>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        )
      )}
    </TemplateTwentyOneSectionWithSubsections>
  );
};
